import { Component, OnInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { IResponse } from 'src/app/interfaces/IResponse';
import { Subscription } from 'rxjs';
import { GroupService } from '../../../../services/repositories/group.service';
import { TranslationService } from 'src/app/services/utilities/translation.service';
import { AuthService } from 'src/app/services/utilities/auth.service';
import { PostService } from 'src/app/services/repositories/post.service';
import {SocialMediaService} from 'src/app/services/repositories/social-media.service';
import { environment } from 'src/environments/environment';
import { Debug } from 'src/app/utils/debug';
import { SocialMediaAPIService } from 'src/app/services/utilities/socialMediaApi.service';
import { ICON } from 'src/app/interfaces/ModalIcon';
import { HttpClient } from '@angular/common/http';
interface PageSelection {
  pageId: string;
  selected: boolean;
  selectedGroup: any; // Peut être typé plus précisément selon la structure de group.group
}

@Component({
  selector: 'app-choose-page',
  templateUrl: './choose-page.component.html',
  styleUrls: ['./choose-page.component.scss'],
})
export class ChoosePageComponent implements OnInit {
  isModalOpen: boolean = false;
  subHeading: string = "";
  heading: string = "";
  modalIcon: ICON = ICON.warning;
  isDropdownOpen: boolean = false;
  selectedItemId: string | null = null;
  type: string = '';
  socialMediaId: string = '';
  pages: any[] = [];
  selectedPageId: string = '';
  infoMessage: string | null = null;
  UserAccreditations!: any;
  isUserSuperAdmin!: boolean;
  data: any = {};
  currentGroup: any = null;
  groupsFlatList: any = [];
	private apiUrl = environment.apiUrl;
	redirect: boolean = false;
  groups: IResponse = {
    data: [],
    navigation: {
      page: 0,
      totalPages: 0,
      totalRows: 0,
      itemsPerPage: 0,
    },
    success: false,
    error: '',
    status: 0,
  };
  selectedPages: PageSelection[] = [];
  disableSubmitButton: boolean = false;
  connectAllPages: boolean = false;
  continueConnectingPages: any;
  

	@ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
	private documentClickListener: (() => void) | null = null;

  subscriptions: Subscription[] =[]

  constructor(
		public postService: PostService,
		private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private socialMediaService: SocialMediaService,
    private groupService: GroupService,
    private authService: AuthService,
    private eRef: ElementRef,
    private renderer: Renderer2,
    private translationService: TranslationService,
    private socialMediaAPI: SocialMediaAPIService
  ) {}
  reconnected:any=null

  ngOnInit() {
    //check if reconnecting in progress
    const storedReconnectedPage = localStorage.getItem(environment.reconnectPageKey)
    this.reconnected=storedReconnectedPage?JSON.parse(storedReconnectedPage):null

		if (this.redirect) {
			window.location.href = `localhost:4200`;
		}
    this.socialMediaId = this.route.snapshot.paramMap.get('id') || '';
    this.fetchPages();

    this.subscriptions.push(this.authService.loadCurrentUser().subscribe((user: any) => {
			console.log("user (choosepage)", user)
      this.UserAccreditations = user.data.accreditations;

      this.isUserSuperAdmin = user.data.isAdmin;
      this.data = this.getAccreditedGroups();
      if (!this.isUserSuperAdmin) {
        this.postService.updateGroup(this.UserAccreditations[0].group);
        this.groupsFlatList = this.getAccreditedGroups();
        if (this.groupsFlatList.length == 1) {
          this.currentGroup = this.groupsFlatList[0].group;
        }
        this.setupReconnectedPageGroup()
      } else {
        const adminGroup = this.postService.getAdmniGroupFromLocalStorage();
        this.subscriptions.push(this.groupService.getGroupByIds(adminGroup).subscribe((groups: any) => {
          this.groupsFlatList = [];
          // console.log(groups.data)
          for (let group of groups.data) {
              this.groupsFlatList.push({ group });
          }
          if (this.groupsFlatList.length == 1) {
            this.currentGroup = this.groupsFlatList[0].group;
          }
         this.setupReconnectedPageGroup()
        }));
      }
      // Listen for changes in currentGroups for superadmin as well
      this.subscriptions.push(this.postService.currentGroups.subscribe((groupIds: any) => {
        this.subscriptions.push(this.groupService.getGroupByIds(groupIds).subscribe((res: any) => {
          let flatGroupList = res.data;
          this.groupsFlatList = flatGroupList.map((g: any) => {
            return {
              group: g,
            };
          });
        }));
      }));
    }));
  }
  setupReconnectedPageGroup(){
    console.log(this.reconnected)
    const group=this.groupsFlatList.find((g:any)=>g.group.id===this.reconnected.groupId).group
    this.reconnected.group=group
    console.log("finding group",this.reconnected)
  }
  getAccreditedGroups() {
    if (this.isUserSuperAdmin) {
      return [];
    }
    const accg: any = [];
    for (let accreditation of this.UserAccreditations) {
      function recurseGroups(group: any, profile: any) {
        // Push the current group and profile to the result
        accg.push({ group: group, profile: profile });

        // Recursively process each child group if they exist
        if (group.children && group.children.length > 0) {
          for (let child of group.children) {
            recurseGroups(child, profile);
          }
        }
      }

      if (accreditation.applyToSubGroups) {
        recurseGroups(accreditation.group, accreditation.profile);
      } else {
        accg.push({
          group: accreditation.group,
          profile: accreditation.profile,
        });
      }
    }

    return accg;
  }

  availableGroups(page:any){
    // exclude group that already has the same connected page from the group list
    return this.groupsFlatList.filter((g:any)=>g.group.socialMedia.every((p:any)=>!page.id.includes(p.pageId)))
  }
  getTranslation(key: string): string {
    return this.translationService.t(key);
  }
  isReconnectedPageCorrect:boolean=true
  fetchPages() {
    this.subscriptions.push(this.socialMediaService
      .getPagesFromSocialMedia(this.socialMediaId)
      .subscribe(
        (data) => {
          this.pages = data.data; // Assign the data to your component's property here
					if ((!this.pages || this.pages.length == 0) && this.reconnected==null) {
						this.infoMessage = "pages.noPagesInfo"
					} else {
            if(this.reconnected){
              const reconnectPage = this.pages.find((p:any)=>p.id==this.reconnected.id)
              if(!reconnectPage)this.isReconnectedPageCorrect=false
            }
            const patterns = ['google', 'facebook', 'linkedin', 'instagram'];
						if (this.pages.length === 1) {
							this.selectedPageId = this.pages[0].id; // Automatically select the single page
						}
            for (const pattern in patterns) {
              if (this.pages[0]?.url.includes(patterns[pattern])) {
                this.type = patterns[pattern];
                break;
              }
            }
          }
          this.pages.forEach(page => {
            this.selectedPages.push({
              pageId: page.id,
              selected: true,
              selectedGroup: null // Par défaut, aucun groupe sélectionné
            });
          });
        },
        (error) => {
          console.error('Error fetching pages:', error);
          // Handle the error appropriately
        }
      ));
  }

  onSubmit() {
    if(this.reconnected){
      console.log("reconnecting page ",this.reconnected,this.socialMediaId)
      this.socialMediaService.reconnectPage({
        id:this.reconnected.id,
        pageId:this.reconnected.pageId,
        tempPageId:this.socialMediaId
      }).subscribe((res:any)=>{
        console.log(res)
        localStorage.removeItem(environment.reconnectPageKey)
        this.router.navigate(['/social-medias']);
      })
    }else{
      this.disableSubmitButton = true;
      if(this.groupsFlatList.length == 1 && this.pages.length == 1){
        this.selectedPages[0].selectedGroup = this.groupsFlatList[0].group.id
      }
      let pages: any = [];
      this.selectedPages.forEach((page: any) => {
        if(page.selectedGroup){
          pages.push({
            pageId: page.pageId,
            groupId: page.selectedGroup
          });
        }
      });
      if(pages.length == 0){
        this.subHeading = 'generic.selectGroupFirst';
        this.isModalOpen = true;
        this.disableSubmitButton = false; 
        return;     
      }
      if(this.selectedPages.length != pages.length){
        this.subHeading = 'generic.selectGroupForAllPages';
        this.connectAllPages = true;
        this.isModalOpen = true;
        this.disableSubmitButton = false;
        this.continueConnectingPages = pages;
        return;     
      }
      this.connectPages(pages);    
    }
  }

  connectPages(pages: any) {
    this.subscriptions.push(this.socialMediaService
      .updateSelectedPage(
        this.socialMediaId,
        pages,
      )
      .subscribe(
        (response) => {
          // Handle the response
          console.log('Social Media enregistré !');
          console.log('response', response);
          if(response.data.pagesIdsFailed.length == 0){
            this.subscriptions.push( this.socialMediaAPI
               .fetchPagePosts(response.data.pagesIdsSuccess)
               .subscribe((res: any) => {}));
            this.router.navigate(['/social-medias']);
          }else{
            const pagesNames = response.data.pagesIdsFailed
            .map((pageId: any) => this.pages.find((p: any) => p.id === pageId)?.name)
            .filter(Boolean) 
            .join(', ');

            this.heading = response.data.pagesIdsFailed.length === 1 
            ? 'generic.errorInConnexionPage' 
            : 'generic.errorInConnexionPages';

            this.subHeading = pagesNames;
            this.isModalOpen = true;
            return
          }
        },
        (error) => {
          // Handle the error
          console.error('Error saving page:', error);
        }
      ));
  }


  toggleDropdown(event: MouseEvent | null = null) {
		event?.stopPropagation(); // Prevent the click from bubbling to the document listener
    this.isDropdownOpen = !this.isDropdownOpen;

    if (this.isDropdownOpen) {
      this.documentClickListener = this.renderer.listen('document', 'click', (event) => {

        // Check if the click is outside the dropdown container
        if (!this.dropdownContainer.nativeElement.contains(event.target)) {
          this.closeDropdown();
        }
      });
    } else {
      this.removeDocumentClickListener();
    }
  }

  closeDropdown() {
    this.isDropdownOpen = false;
    this.removeDocumentClickListener();
  }

  private removeDocumentClickListener() {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }

  ngOnDestroy() {
    this.removeDocumentClickListener(); // Clean up when the component is destroyed
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  selectGroup(group: any) {
    this.currentGroup = group;
    this.toggleDropdown();
  }

  selectItem(page: any) {
    this.selectedItemId = page.id; // Supposons que page a une propriété id pour identifier l'élément sélectionné
    // this.toggleDropdown(); // Fermez le dropdown après la sélection si nécessaire
  }
  // Add methods to handle user's page selection

  //close modal
  close() {
    this.isModalOpen = false;
    this.connectAllPages = false;
    if(this.heading != ""){
      this.router.navigate(['/social-medias']);
    }
  }

  continue(){
    this.connectPages(this.continueConnectingPages);
  }

	logout(): void {
		if (this.type == "linkedin") {
			window.open(`${this.apiUrl}/social-auth/linkedin/logout`, '_blank');
		}
		window.location.href = `${window.location.origin}/social-medias`;
	}
}
